@for (vogrupp of statusGroup; track vogrupp) {
  <div>
    {{ getGruppText(vogrupp) }}
    <ul>
      @for (generation of vogrupp.generationer; track generation) {
        <li>
          <i class="far" aria-hidden="true"
            [ngClass]="getStyle(generation.status).icon"
          [style.color]="getStyle(generation.status).color"></i>
          {{ getText(generation.status) }} (Gen. {{generation.generation}})
        </li>
      }
    </ul>
  </div>
}
@if (statusGroup.length === 0) {
  <div>
    {{ texts.saknas }}
  </div>
}
